"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossOriginValue = exports.PreloadType = void 0;
var PreloadType;
(function (PreloadType) {
    PreloadType["NONE"] = "none";
    PreloadType["METADATA"] = "metadata";
    PreloadType["AUTO"] = "auto";
})(PreloadType || (PreloadType = {}));
exports.PreloadType = PreloadType;
var CrossOriginValue;
(function (CrossOriginValue) {
    CrossOriginValue["ANONYMUS"] = "anonymous";
    CrossOriginValue["CREDENTIALS"] = "use-credentials";
})(CrossOriginValue || (CrossOriginValue = {}));
exports.CrossOriginValue = CrossOriginValue;
//# sourceMappingURL=types.js.map